import React from 'react'
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Layout from './component/layout'
import Payment from "./pages/payment";
import Page404 from "./pages/404";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60,
        },
    },
})
export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Page404/>}/>
                        <Route path="transaction/:code" element={<Payment/>}/>
                        <Route path="*" element={<Page404/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </QueryClientProvider>
    );
}